import React from 'react'
import { connect } from 'react-redux'
// import FoodItem from './FoodItem';
import { deleteFoodItem,  } from '../actions/'

function DisplaysFoodItems(props){
    const { isLoading, allFoodItems } = props


    if(isLoading){
        return <p>Items Loading...</p>
    }

    return (
        <section>
            <h2>All Food Items:</h2>
            <div className="fooditemwrapper">
                {allFoodItems.map((foodItem)=>{
                    return (
                    <div className="fooditem" key={foodItem.id}>
                    <p>Food Item Selection ID: {foodItem.id}</p>
                    <p>Food Item: {foodItem.name}</p>
                    <p>Pickup Time: {foodItem.time}</p>
                    <p>Pickup Date: {foodItem.pickup_date}</p>
                    <p>Description: {foodItem.description}</p>
                    <p>Is it Claimed?: {foodItem.is_claimed}</p>
                    {/* <button type="button">I will pick this up!</button> <br />
                    <button type="button">Modify Food Item</button>
                    <button type="button" onClick={e => deleteFoodItem(e.id)}>Delete Food Item</button> */}
                    </div>)
                })}
            </div>
        </section>
    )
}

const mapStateToProps = (state) => {
    return {
        allFoodItems: state.allFoodItems,
        isLoading: state.isLoading,
        errorMessage: state.errorMessage,
    }
}

const mapDispatchToProps = {
    deleteFoodItem
}

export default connect(mapStateToProps, mapDispatchToProps)(DisplaysFoodItems)

